/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing/subscription', { accountScoped: true, apiVersion: 'v2' });
  }

  get() {
    return axios.get(this.url);
  }

  checkout() {
    return axios.post(`${this.url}/checkout`);
  }

  portal() {
    return axios.post(`${this.url}/portal`);
  }
}

export default new BillingAPI();
